module.exports = __webpack_public_path__ + "media/img/event/speakers/Adam-Cawkwell-21845cb6f94a67f81733d8ed9b3219f4.jpg";